 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-048d4e0a":"cbc0f44b","chunk-08a643aa":"b2ee5a02","chunk-853488d4":"ebc71291","chunk-d83e313a":"064091dc","chunk-14605524":"06c20ce9","chunk-18c2825b":"be4347ae","chunk-1a481ba0":"c2687465","chunk-20b1210a":"f37f39c4","chunk-7b10932e":"88840143","chunk-d10560c8":"bcb8fbae","chunk-002884cc":"e3b3e0ce","chunk-d9cfd946":"5958f855","chunk-2d0dd7ce":"5db064a7","chunk-2d22c341":"ca25b283","chunk-3256e0fb":"5f56f50b","chunk-32fa970a":"496371e7","chunk-3a4796d4":"c634a90c","chunk-4673d68e":"2c4ef869","chunk-4da80f9c":"a6555e5b","chunk-548b3f40":"28b03f2d","chunk-5706edc7":"323b6e57","chunk-59c47205":"43adc200","chunk-661fdd9c":"5aa5fc7b","chunk-744eed33":"bade4f71","chunk-02a8dc40":"b0da8587","chunk-09f1828c":"b4dc095c","chunk-0b3a64ab":"1a0850ef","chunk-0ba3f96c":"c6c777ec","chunk-14a67086":"a1efb3c7","chunk-9a59aac4":"1c25def3","chunk-29acf3ec":"7e10b067","chunk-47e787b3":"d8726710","chunk-5893ed14":"924e54c2","chunk-76b771fc":"d97b79e5","chunk-76efcef6":"76affb1e","chunk-3b0e431b":"7d2e6234","chunk-7343b651":"5ad46edf","chunk-06abc79a":"a3d6a048","chunk-95be4018":"c1762f7a","chunk-ca83363c":"e7a4d5f3","chunk-f1c8d3b8":"b5ab6f21","chunk-fdaf1a80":"4b884512","chunk-1efe764d":"091a9e7f","chunk-23bc2ad3":"b46ff9a4","chunk-75634ce0":"8be7e4f8","chunk-98c84eee":"00aa5fa4","chunk-dbac0192":"4d768264","chunk-2d0ae5d6":"c76b151c","chunk-b3ccb4f8":"3847106b","chunk-bc1a71cc":"3f9caaee","chunk-be1520d4":"237ca464","chunk-c2879400":"b9b9778f","chunk-d974aeca":"fce3c6b2","chunk-f004240c":"3f8125f6","chunk-2d0e6306":"17d6f4b5","chunk-75f8d961":"9c0ccc13","chunk-f762e4d8":"8cc7cff2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-048d4e0a":1,"chunk-14605524":1,"chunk-18c2825b":1,"chunk-1a481ba0":1,"chunk-7b10932e":1,"chunk-d10560c8":1,"chunk-002884cc":1,"chunk-d9cfd946":1,"chunk-3256e0fb":1,"chunk-3a4796d4":1,"chunk-4673d68e":1,"chunk-4da80f9c":1,"chunk-548b3f40":1,"chunk-5706edc7":1,"chunk-661fdd9c":1,"chunk-744eed33":1,"chunk-02a8dc40":1,"chunk-09f1828c":1,"chunk-0b3a64ab":1,"chunk-0ba3f96c":1,"chunk-14a67086":1,"chunk-9a59aac4":1,"chunk-29acf3ec":1,"chunk-47e787b3":1,"chunk-5893ed14":1,"chunk-76b771fc":1,"chunk-76efcef6":1,"chunk-3b0e431b":1,"chunk-06abc79a":1,"chunk-95be4018":1,"chunk-ca83363c":1,"chunk-f1c8d3b8":1,"chunk-fdaf1a80":1,"chunk-1efe764d":1,"chunk-23bc2ad3":1,"chunk-75634ce0":1,"chunk-98c84eee":1,"chunk-dbac0192":1,"chunk-b3ccb4f8":1,"chunk-bc1a71cc":1,"chunk-c2879400":1,"chunk-d974aeca":1,"chunk-f004240c":1,"chunk-75f8d961":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-048d4e0a":"30461311","chunk-08a643aa":"31d6cfe0","chunk-853488d4":"31d6cfe0","chunk-d83e313a":"31d6cfe0","chunk-14605524":"7c0cc1f9","chunk-18c2825b":"652b36a7","chunk-1a481ba0":"46a2fd40","chunk-20b1210a":"31d6cfe0","chunk-7b10932e":"04cafe66","chunk-d10560c8":"2cabe5d8","chunk-002884cc":"72679650","chunk-d9cfd946":"dfcdfc35","chunk-2d0dd7ce":"31d6cfe0","chunk-2d22c341":"31d6cfe0","chunk-3256e0fb":"ceda5290","chunk-32fa970a":"31d6cfe0","chunk-3a4796d4":"64f82e38","chunk-4673d68e":"af315127","chunk-4da80f9c":"986c7b6a","chunk-548b3f40":"412ec912","chunk-5706edc7":"cbf26267","chunk-59c47205":"31d6cfe0","chunk-661fdd9c":"7c6de00d","chunk-744eed33":"ba58b102","chunk-02a8dc40":"0c07b176","chunk-09f1828c":"d3deae4d","chunk-0b3a64ab":"e0dfb4b3","chunk-0ba3f96c":"d3ee8bdc","chunk-14a67086":"1fa54808","chunk-9a59aac4":"0ad0c37a","chunk-29acf3ec":"7c9b95ee","chunk-47e787b3":"d3ca95b2","chunk-5893ed14":"48f1f48f","chunk-76b771fc":"9b0342d8","chunk-76efcef6":"1efa0544","chunk-3b0e431b":"a4d27ffd","chunk-7343b651":"31d6cfe0","chunk-06abc79a":"f38374eb","chunk-95be4018":"4c523550","chunk-ca83363c":"98a60422","chunk-f1c8d3b8":"0c07b176","chunk-fdaf1a80":"3a0da93c","chunk-1efe764d":"04be0862","chunk-23bc2ad3":"af0f9af6","chunk-75634ce0":"04be0862","chunk-98c84eee":"ad3254cb","chunk-dbac0192":"a8afcae9","chunk-2d0ae5d6":"31d6cfe0","chunk-b3ccb4f8":"4a615c50","chunk-bc1a71cc":"dd5276c0","chunk-be1520d4":"31d6cfe0","chunk-c2879400":"c1a279f9","chunk-d974aeca":"487ebe7e","chunk-f004240c":"1ace08f8","chunk-2d0e6306":"31d6cfe0","chunk-75f8d961":"695af79a","chunk-f762e4d8":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/smartclinic/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
